import { render } from "./AppointmentReviewModal.vue?vue&type=template&id=07dfd516&scoped=true"
import script from "./AppointmentReviewModal.vue?vue&type=script&lang=js"
export * from "./AppointmentReviewModal.vue?vue&type=script&lang=js"

import "./AppointmentReviewModal.vue?vue&type=style&index=0&id=07dfd516&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07dfd516"]])

export default __exports__